import { useState, useEffect } from "react";

function useUserRole() {
  // Initialize from localStorage if available
  const [role, setRole] = useState(() => {
    try {
      const userData = localStorage.getItem('user');
      if (userData) {
        const user = JSON.parse(userData);
        const userRole = user.role?.toLowerCase() || null;
        
        // Ensure role is stored in localStorage for consistency
        if (userRole) localStorage.setItem("role", userRole);
        
        return userRole;
      }
      
      // If no user data, check if role is stored separately
      const storedRole = localStorage.getItem("role");
      if (storedRole) return storedRole.toLowerCase();
    } catch (error) {
      console.error('Error parsing user data:', error);
    }
    return null;
  });

  useEffect(() => {
    const fetchUserRole = () => {
      try {
        const userData = localStorage.getItem('user');
        let newRole = null;
        
        if (userData) {
          const user = JSON.parse(userData);
          newRole = user.role?.toLowerCase();
          
          // Update localStorage with role
          if (newRole) localStorage.setItem("role", newRole);
        } else {
          // If no user data, check if role is stored separately
          const storedRole = localStorage.getItem("role");
          newRole = storedRole ? storedRole.toLowerCase() : null;
        }
        
        if (newRole !== role) {
          setRole(newRole);
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
        setRole(null);
      }
    };

    // Initial fetch
    fetchUserRole();

    // Add event listener for storage changes
    const handleStorageChange = () => {
      fetchUserRole();
    };

    // Listen for both storage events and custom events
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('userDataChanged', handleStorageChange);

    // Check periodically for changes (backup mechanism)
    const interval = setInterval(fetchUserRole, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userDataChanged', handleStorageChange);
      clearInterval(interval);
    };
  }, []); // Remove role dependency to prevent circular updates

  return { role, isLoading: role === null };
}

export default useUserRole;